

import { NgModule } from '@angular/core';
import { TnxSharedModule } from 'tnx-shared';
import { BasePermissionFormComponent } from './basepermission-form/basepermission-form.component';
import { BasepermissionImportFormComponent } from './basepermission-import-form/basepermission-import-form.component';
import { BasePermissionComponent } from './basepermission.component';
import { BasePermissionRoutes } from './basepermission.routing';

export function declaration() {
    return [BasePermissionComponent, BasePermissionFormComponent, BasepermissionImportFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class BasePermissionModule {
}

@NgModule({
    imports: [BasePermissionModule, BasePermissionRoutes],
    exports: [BasePermissionModule]
})
export class BasePermissionWithRouteModule {
}
